<template>
    <div class="center">
        <p class="pd" style="display: flex;align-items: center">请选择延长日期 <el-date-picker
                style="width: 230px;"
                v-model="value"
                type="date"
                placeholder="选择日期">
        </el-date-picker></p>
        <span slot="footer" class="dialog-footer"  style="padding-bottom: 20px">
    <el-button @click="cancel1">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="cancel1">确 定</el-button>
  </span>
    </div>
</template>
<script>

    import data from "../data.json"
    export default {
        name: 'deliveryDialog',
        props:{

        },
        data() {
            return {
                value:''
            }
        },
        mounted() {


        },
        methods:{
            cancel1(){
                this.$emit('close1')
            }
        }
    }
</script>
<style lang="scss" scoped>
.center{
    display: flex;
    align-items: center;
    flex-direction:column;
}
.pd{
    padding: 20px 0 0 0;
}
</style>